module.exports = __webpack_public_path__ + "img/skype.9edb1c83.jpg";